<div class="row">
  <div class="col-sm-12">
    <h2 class="text-primary mt-3">{{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.PersonType.Title' | translate}}</h2>
  </div>
</div>

<!-- Tipologia de pessoa -->
<div class="row">
  <div class="col-sm-4">
    <div class="form-group">
      <fieldset disabled>

        <label class="disabled">
          <span class="mandatory">*</span>
          {{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.PersonType.Fields.PersonType' | translate}}
          <span class="ml-1 text-primary icon-help" aria-label="Tooltip com informação" tooltip="{{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryList.Fields.PersonTypology' | translate}}"></span>
        </label>
        <div class="btn-group btn-group-toggle">
          <label *ngFor="let dropdown of dropDownPersonTypes.slice().reverse()" tabindex="0" class="btn btn-toogle" [class.active]="dropdown.value==cardData.personTypologyCode" [radioLabel]="personTypology">
            <input type="radio"
                   [(ngModel)]="cardData.personTypologyCode"
                   name="personTypologyCode"
                   #personTypologyCode="ngModel"
                   (change)="personTypelogyCodeChanged(dropdown)"
                   [value]="dropdown.value"
                   required
                   disabled
                  >
            {{dropdown.description}}
          </label>
          <span></span>
          <div [style.visibility]="(cardData.personTypologyCode== null || cardData.personTypologyCode==undefined)?'visible':'hidden'"
                class="invalid-feedback">
          {{'ValidationMessages.required' | translate}}
          </div>
         <!-- <validation-message [control]="personTypologyCode" ></validation-message>-->
        </div>
      </fieldset>
    </div>
  </div>

</div>
